
// Only supported in Node.js >= 15

import { webcrypto } from 'crypto';

export default webcrypto;
